import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/hooks/use-toast";

interface BunadContactFormProps {
  bunadTitle: string;
}

const BunadContactForm = ({ bunadTitle }: BunadContactFormProps) => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast({
      title: "Melding sendt!",
      description: `Vi tar kontakt med deg angående ${bunadTitle} så snart som mulig.`,
    });
    setFormData({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <section className="section-padding bg-cream">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-primary font-sans text-xs tracking-[0.3em] uppercase mb-4">
            Ta kontakt
          </p>
          <h2 className="font-serif text-3xl md:text-4xl text-foreground mb-4">
            Kontakt oss om {bunadTitle}
          </h2>
          <p className="text-muted-foreground font-sans">
            Har du spørsmål om denne drakten? Fyll ut skjemaet under, så tar vi kontakt.
          </p>
        </div>

        <div className="bg-card p-8 lg:p-10 shadow-medium">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Input
                placeholder="Ditt navn"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                className="h-12 border-border bg-background font-sans"
              />
            </div>
            <div>
              <Input
                type="email"
                placeholder="E-postadresse"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="h-12 border-border bg-background font-sans"
              />
            </div>
            <div>
              <Input
                type="tel"
                placeholder="Telefonnummer"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                className="h-12 border-border bg-background font-sans"
              />
            </div>
            <div>
              <Textarea
                placeholder={`Din melding om ${bunadTitle}`}
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                required
                rows={5}
                className="border-border bg-background font-sans resize-none"
              />
            </div>
            <Button type="submit" variant="hero" size="lg" className="w-full">
              Send melding
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default BunadContactForm;
